export default __webpack_public_path__ + "static/media/noQuotes.a62f3edc.svg";